import { forwardRef } from "react";
import IconKeyboardArrowLeft from "@servicetitan/hammer-icon/mdi/round/keyboard_arrow_left.svg";
import IconKeyboardArrowRight from "@servicetitan/hammer-icon/mdi/round/keyboard_arrow_right.svg";

import { Button } from "../../Button";

import cx from "classnames";
import itemStyles from "./PaginationItem.module.scss";
import styles from "./PaginationList.module.scss";

type PaginationListProps = {
  page: number;
  totalPages: number;
  hasTotalItemCount?: boolean;
  onPageChange: (page: number) => void;
  children: React.ReactNode;
  className?: string;
};

export const PaginationList = forwardRef<HTMLUListElement, PaginationListProps>(
  (props, ref) => {
    const {
      page,
      totalPages,
      hasTotalItemCount,
      children,
      onPageChange,
      className,
    } = props;

    const paginationListClassName = cx(styles["pagination-list"], className);

    return (
      <ul ref={ref} className={paginationListClassName}>
        <li className={itemStyles["pagination-item"]}>
          <Button
            appearance="ghost"
            icon={IconKeyboardArrowLeft}
            size="small"
            aria-label="Previous page"
            disabled={page === 1}
            onClick={() => {
              if (page > 1) {
                onPageChange?.(page - 1);
              }
            }}
          />
        </li>
        {children}
        <li className={itemStyles["pagination-item"]}>
          <Button
            appearance="ghost"
            icon={IconKeyboardArrowRight}
            size="small"
            aria-label="Next page"
            disabled={
              hasTotalItemCount !== false &&
              (totalPages === 0 || page === totalPages)
            }
            onClick={() => {
              if (totalPages === 0 || page < totalPages) {
                onPageChange?.(page + 1);
              }
            }}
          />
        </li>
      </ul>
    );
  },
);

PaginationList.displayName = "PaginationList";
